import { Col } from "react-bootstrap";
import AnuncioForm from "../components/AnuncioForm";



export const Rotas = [
  {
    name: 'Home',
    link: 'dashboard',
    element: (
      <Col xs={12}>
         <AnuncioForm/>
      </Col>
    ),
    tipoUser: 'Técnico',
  },

  {
    name: 'Nova Lista de Atividades',
    link: 'inserir-timesheet',
    element: (
      <>
        
      </>
    ),
    tipoUser: 'Técnico',
  },
  {
    name: 'Estado das Atividades',
    link: 'estado-atividades',
    element: (
      <>
       
      </>
    ),
    tipoUser: 'Técnico',
  },
  {
    name: 'Lista de Atividades',
    link: 'activities-list',
    element: (
      <>
      
      </>
    ),
    tipoUser: 'Técnico',
  },
  {
    name: 'Histórico de Atividades',
    link: 'historico',
    element: (
      <>
        
      </>
    ),
    tipoUser: 'Técnico',
  },

  {
    name: 'Avisos',
    link: 'avisos',
    element: (
      <>
       
      </>
    ),
    tipoUser: 'Técnico',
  },
  {
    name: 'Home',
    link: 'dashboard',
    element: (
      <Col xs={6}>
       
      </Col>
    ),
    tipoUser: 'Admin',
  },
  {
    name: 'Atividades Pendentes',
    link: 'atividades-pendentes',
    element: (
      <>
        
      </>
    ),
    tipoUser: 'Admin',
  },
  {
    name: 'Lista de Técnicos',
    link: 'lista-tecnicos',
    element: (
      <>
       
      </>
    ),
    tipoUser: 'Admin',
  },
  {
    name: 'Historico',
    link: 'historico-admin',
    element: (
      <>
    
      </>
    ),
    tipoUser: 'Admin',
  },
  {
    name: 'Gestão de Atividades',
    link: 'gestao-atividades',
    element: (
      <>
    
      </>
    ),
    tipoUser: 'Admin',
  },
  {
    name: 'Estatísticas',
    link: 'stats-atividades',
    element: (
      <>
        
      </>
    ),
    tipoUser: 'Admin',
  },
]
